import { useReducer } from "react";
import phoneFormater from "swedish-phone-number-formatter";

import TextInput from "@krea/common/shared-components/fields/input";
import {
  useIsFieldRequestSubmitting,
  usePostFieldRequest,
} from "@krea/common/store/field-requests/hooks/mutations";
import { useGetOneFieldRequest } from "@krea/common/store/field-requests/hooks/queries";

const PhoneNumberForm = ({ fieldRequestID, withInputLabel }) => {
  const isFieldRequestSubmitting = useIsFieldRequestSubmitting(fieldRequestID);
  const { data: { submittedData = "", displayName } = {} } =
    useGetOneFieldRequest(fieldRequestID);
  const { mutate: postFieldRequest, error: err } =
    usePostFieldRequest(fieldRequestID);

  const error = err?.data?.errors?.[0]?.message;

  function reducer(state, action) {
    switch (action.type) {
      case "touched":
        return { ...state, touched: action.payload };
      case "changePhoneNumber":
        return {
          ...state,
          value: action.payload,
          touched: state.value !== action.payload,
        };
      default:
        throw new Error();
    }
  }

  const [state, setState] = useReducer(reducer, {
    value: submittedData,
    touched: false,
  });

  const { value } = state;

  const formatedNumber = phoneFormater(value) || "";

  const onBlur = (state) => {
    const { touched, value } = state;

    if (touched) {
      postFieldRequest(value);
      setState({ type: "touched", payload: false });
    }
  };

  const onChange = (e) => {
    const value = e.target.value.replace(/\D+/g, "");

    setState({ type: "changePhoneNumber", payload: value });
  };

  return (
    <TextInput
      type="tel"
      className="phone-input"
      label={withInputLabel && displayName}
      value={formatedNumber}
      onChange={(e) => onChange(e, state)}
      onBlur={() => onBlur(state)}
      placeholder="t.ex 070 123 45 67"
      error={error}
      saved={isFieldRequestSubmitting}
    />
  );
};

export default PhoneNumberForm;
